<p-toast></p-toast>
<div class="container-fluid container-fullw">
  <div class="p-fluid p-grid">
    <div class="p-col-12">
      <div>
        <p-fieldset [toggleable]="true">
          <ng-template pTemplate="header">
            <span *ngIf="sharing.id === null">{{ 'NEWSHARING' | translate }}</span>
            <span *ngIf="sharing.id !== null">{{ 'EDITSHARING' | translate }}</span>
          </ng-template>
          <form pFocusTrap name="sharingForm" id="sharingForm" novalidate (ngSubmit)="submitForm(true)" [formGroup]="sharingForm" >
            <input type="hidden" name="id" id="sharingId" formControlName="id" />
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-tag"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="sharingName" formControlName="name" type="text" pInputText [required]="true"> 
                      <label for="sharingName" class="req">{{ 'NAME' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="sharingForm.controls['name'].invalid && (sharingForm.controls['name'].dirty || sharingForm.controls['name'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="sharingForm.controls['name'].errors !== null">
                  <div *ngIf="sharingForm.controls['name'].errors.required">
                   {{ 'NAMEREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-marker-alt"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="sharingNameAr" formControlName="nameAr" type="text" pInputText [required]="false"> 
                      <label for="sharingNameAr" class="">{{ 'NAMEAR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-marker-alt"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="sharingNameFr" formControlName="nameFr" type="text" pInputText [required]="false"> 
                      <label for="sharingNameFr" class="">{{ 'NAMEFR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <label for="sharingMode" class="req">{{ 'MODE' | translate }}</label>
                  <div class="p-formgroup-inline">
                    <div class="p-field-checkbox" *ngFor="let option of sharingsColumnsService.modesOptions; let i = index">
                      <p-radioButton inputId="sharingMode_{{ i }}" formControlName="mode" name="mode" [value]="option.value"></p-radioButton>
                      <label for="sharingMode_{{ i }}">{{ option.label | translate }}</label>
                    </div>
                  </div>
                </div>
                <div *ngIf="sharingForm.controls['mode'].invalid && (sharingForm.controls['mode'].dirty || sharingForm.controls['mode'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="sharingForm.controls['mode'].errors !== null">
                  <div *ngIf="sharingForm.controls['mode'].errors.required">
                   {{ 'MODEREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-marker-alt"></i>
                    </span>
                    <span class="p-float-label">
                      <p-inputNumber inputId="sharingPercentage" formControlName="percentage" [step]="1" [showButtons]="true" [required]="true"></p-inputNumber>
                      <label for="sharingPercentage" class="req">{{ 'PERCENTAGE' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="sharingForm.controls['percentage'].invalid && (sharingForm.controls['percentage'].dirty || sharingForm.controls['percentage'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="sharingForm.controls['percentage'].errors !== null">
                  <div *ngIf="sharingForm.controls['percentage'].errors.required">
                   {{ 'PERCENTAGEREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-marker-alt"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="sharingCurrency" formControlName="currency" type="text" pInputText [required]="true"> 
                      <label for="sharingCurrency" class="req">{{ 'CURRENCY' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="sharingForm.controls['currency'].invalid && (sharingForm.controls['currency'].dirty || sharingForm.controls['currency'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="sharingForm.controls['currency'].errors !== null">
                  <div *ngIf="sharingForm.controls['currency'].errors.required">
                   {{ 'CURRENCYREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-marker-alt"></i>
                    </span>
                    <span class="p-float-label">
                      <p-inputNumber inputId="sharingAmount" formControlName="amount" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2" [step]="0.1" [showButtons]="true" [required]="true"></p-inputNumber>
                      <label for="sharingAmount" class="req">{{ 'AMOUNT' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="sharingForm.controls['amount'].invalid && (sharingForm.controls['amount'].dirty || sharingForm.controls['amount'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="sharingForm.controls['amount'].errors !== null">
                  <div *ngIf="sharingForm.controls['amount'].errors.required">
                   {{ 'AMOUNTREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->

            <div class="p-fluid p-grid">
              <div class="p-col-4">
                <button (click)="list()" class="btn btn-primary pull-left">
                  <i class="icon-layout-list-thumb"></i>
                  <span class="p-ml-1">{{ 'BACKSHARINGS' | translate }}</span>
                </button>
              </div>
              <div class="p-col-4 text-center">
                <button *ngIf="sharing.id !== null" type="button" (click)="submitForm(false)" class="btn btn-primary" [disabled]="!sharingForm.valid || disableSubmit"> <!--  [disabled]="sharingForm.$invalid" -->
                  <i class="fas fa-spinner fa-spin" *ngIf="disableSubmit && !redirect"></i>
                  <i class="fas fa-check-circle" *ngIf="!(disableSubmit && !redirect)"></i>
                  <span class="p-ml-1"> {{ 'APPLY' | translate }}</span>
                </button>
              </div>
              <div class="p-col-4">
                <button type="button" (click)="submitForm(true)" class="btn btn-primary pull-right" [disabled]="disableSubmit"> <!--  [disabled]="!sharingForm.valid || " -->
                  <i class="fas fa-spinner fa-spin" *ngIf="disableSubmit && redirect"></i>
                  <i class="icon-save" *ngIf="!(disableSubmit && redirect)"></i>
                  <span class="p-ml-1">{{ 'SAVE' | translate }}</span>
                </button>
              </div>
            </div>
          </form>
        </p-fieldset>
        <div class="p-fluid p-grid">
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
          <div class="col-sm-12 p-col-4 mb-2 text-center">
          </div>
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
        </div>
      </div>
    </div><!--/p-col-12-->
  </div><!--/p-fluid p-grid-->
  <p-scrollTop target="parent"></p-scrollTop>
</div><!--/container-fluid container-fullw-->
<!-- end: FORM -->

